import { createEffect, createEvent } from 'effector'

import { APIError, APIResult } from '../../core/api/Result'
import { AppAPI } from '../../services/api/App'

export const setGlobalLoadingFx = createEvent<boolean>()
export const setAppInfoModeFx = createEvent<number>()
export const setAppLoadingFx = createEvent<boolean>()

export const setAppPriceFx = createEvent<number | string>()

export const getApplicationPingFx = createEffect<unknown, APIResult<typeof AppAPI['getApplicationPing']>, APIError>(
  AppAPI.getApplicationPing,
)

export const getProjectsPingFx = createEffect<unknown, APIResult<typeof AppAPI['getProjectsPing']>, APIError>(
  AppAPI.getProjectsPing,
)

export const postFilesFx = createEffect(AppAPI.postFiles)

export const setAppDataFx = createEvent<{key: string, value: unknown}>()
